module.exports = __webpack_public_path__ + "img/Slide3.df57b98f.png";